import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import frCommon from "./locales/fr/common.json";
import frHeader from "./locales/fr/header.json";
import frFooter from "./locales/fr/footer.json";
import frHero from "./locales/fr/hero.json";
import frWhatsapp from "./locales/fr/whatsapp.json";
import frLanding from "./locales/fr/landing.json";
import frServices from "./locales/fr/services.json";
import frDevis from "./locales/fr/devis.json";

import arCommon from "./locales/ar/common.json";
import arHeader from "./locales/ar/header.json";
import arFooter from "./locales/ar/footer.json";
import arHero from "./locales/ar/hero.json";
import arWhatsapp from "./locales/ar/whatsapp.json";
import arLanding from "./locales/ar/landing.json";
import arServices from "./locales/ar/services.json";
import arDevis from "./locales/ar/devis.json";

export const SUPPORTED_LANGS = ["fr", "ar"] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export const RTL_LANGS: SupportedLang[] = ["ar"];

export function isRtl(lang: string): boolean {
  return RTL_LANGS.includes(lang as SupportedLang);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    supportedLngs: SUPPORTED_LANGS,
    defaultNS: "common",
    ns: ["common", "header", "footer", "hero", "whatsapp", "landing", "services", "devis"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "cookie", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"],
      lookupLocalStorage: "conceptions_lang",
      lookupCookie: "conceptions_lang",
    },
    resources: {
      fr: {
        common: frCommon,
        header: frHeader,
        footer: frFooter,
        hero: frHero,
        whatsapp: frWhatsapp,
        landing: frLanding,
        services: frServices,
        devis: frDevis,
      },
      ar: {
        common: arCommon,
        header: arHeader,
        footer: arFooter,
        hero: arHero,
        whatsapp: arWhatsapp,
        landing: arLanding,
        services: arServices,
        devis: arDevis,
      },
    },
  });

// Met à jour <html lang> et <html dir> à chaque changement de langue
function applyHtmlAttributes(lang: string) {
  const html = document.documentElement;
  html.lang = lang;
  html.dir = isRtl(lang) ? "rtl" : "ltr";
}

applyHtmlAttributes(i18n.language || "fr");
i18n.on("languageChanged", applyHtmlAttributes);

export default i18n;
